import { yoda } from '@/utils/yoda';
import getAppInfo from '@/utils/appInfo';
import { addParam } from '@/utils/util';
// 通用分享中间页实现方案： https://docs.corp.kuaishou.com/k/home/VRFI1CKSnYik/fcAAWkMS0hIi3LtVVs2ZEEGAl
// 分享对外技术接入文档： https://docs.corp.kuaishou.com/k/home/VK-55pG0glEw/fcADNAUMfGWfT41Zv9u1XBrI_
interface ShareParamType {
    key?: string; // kconf配置名
    platform?: string[]; // 分享渠道
    siteUrl: string; // 分享链接
    imageUrl?: string; // 分享图片（Meta卡片展示）
    showFriends?: boolean; // 是否展示私信
    // needShorten?: boolean; // 是否需要短链，固定传true
    caption?: string; // 分享标题 (手动传递 或 不传则使用kconf配置)
    description?: string // 分享描述 (手动传递 或 不传则使用kconf配置)
}
const appInfo = getAppInfo();

export const share = async (param: ShareParamType, cb?: any) => {

    // 分享链接由客户端默认拼接了shareBucket+kpn参数，兜底再拼接一次
    let siteUrl = addParam(param.siteUrl, {
        shareBucket: appInfo.bucket,
        kpn: appInfo.app,
    });

    let sharePrefix;
    // 线上环境： 直接分享，已经配置了 /events /oact的转发
    if (param.siteUrl.includes('m-live.kwai.com')){
        sharePrefix = siteUrl;
    }
    // 测试环境: 分享中间服务的域名，方便流程测试
    else {
        sharePrefix = 'https://smp.kwai.com/share/middle';
    }

    const shareInfo = {
        title: param.caption,
        description: param.description,
        imageUrl: param.imageUrl,
        key: param.key,
        url: siteUrl, // 中间服务回调地址
    };

    // siteurl 添加分享参数与埋点参数
    siteUrl = addParam(sharePrefix, {
        shareInfo: encodeURIComponent(
            JSON.stringify(shareInfo)
        ),
        share_item_type: `live_h5_activity_${param.key}`,
    });
    console.log('shareSiteUrl: ', siteUrl);

    await yoda.ready();
    yoda.component.selectShare({
        param: {
            ...param,
            siteUrl,
            caption: `${param.caption} ${param.description}`,
            needShorten: true,
        },
    }).then((res: any) => {
        cb && cb(res);
    });
};
export default share;

// 使用示例

// share({
//     key: 'live-midyear',
//     siteUrl: 'https://m-live.kwai.com/events/anchor-incentive',
//     showFriends: true,
//     needShorten: true,
//     caption: '六月活动分享测试',
//     description: '描述-副标题',
// });
// Meta图片配置在kconf https://kconf.corp.kuaishou.com/#/X6Frontend/kwai-share/live-midyear